// Pengurutan A-Z sadar bahasa Indonesia — dipakai untuk SEMUA opsi dropdown
// filter & form yang bersumber dari master data (brand, kategori produk,
// satuan, gudang, supplier, kondisi detail, dst).
//
// KECUALI DUA hal (kontrak B3, brief 23 Agu #1-7):
// 1. Dropdown "Urut:" (`inv-prod-sort`) — urutan pilihannya PUNYA MAKNA
//    sendiri (Nama A-Z lalu Z-A, Brand, Kategori, dst.), bukan daftar nilai
//    yang perlu diabjadkan.
// 2. Kategori AKUNTANSI (Unit Baru/Unit Second/Aksesoris/SIM Sticker) —
//    urutannya mengikuti nomor akun COA (1310/1320/1330/1340), bukan abjad;
//    staf yang hafal "Unit Baru selalu paling atas" tidak boleh harus
//    mencari ulang tiap buka form gara-gara diacak jadi Aksesoris-Unit
//    Baru-Unit Second-SIM Sticker.
//
// `sensitivity: "base"` supaya "unit" dan "Unit" (beda huruf besar/kecil,
// bukan beda makna) tidak dianggap dua kunci urut yang terpisah.
export function urutAZ(daftar, ambilTeks = (x) => x) {
  return [...(daftar || [])].sort((a, b) =>
    String(ambilTeks(a) ?? "").localeCompare(String(ambilTeks(b) ?? ""), "id", { sensitivity: "base" })
  );
}

export default urutAZ;
